import { Sentry } from "./sentryInstrument";

if (typeof window.gettext === "undefined") {
  window.gettext = function(str) { return str; };
}

if (typeof window.ngettext === "undefined") {
  window.ngettext = function(singular, plural, n) {
	return n > 1 ? plural : singular;
  };
}

const countriesDataCache = {};
const updatedEvent = new Event("optionsupdated");

function updateRegionSelect(regions, regionSelect) {
  let selectedRegion = regionSelect.value ? regionSelect.querySelector(`option[value="${regionSelect.value}"]`) : null;
  regionSelect.disabled = true;
  for (let i=regionSelect.options.length-1; i>=0; i--) {
		regionSelect.options.item(i).remove();
  }
  regionSelect.add(new Option("-- " + window.gettext("Select") + " --", "", false, false));
  let matchedSelected = false;
  for (const region of regions ){
		matchedSelected = selectedRegion !== null && region.id == selectedRegion.value;
		regionSelect.add(new Option(region.description, region.id, false, matchedSelected));
		if (matchedSelected) {
			selectedRegion = null;
		}
  }
  if (!matchedSelected && selectedRegion !== null && selectedRegion.dataset.keep) {
		regionSelect.add(selectedRegion);
  }
  regionSelect.disabled = false;
  regionSelect.dispatchEvent(updatedEvent);
}

async function fetchCountryRegions(url, countryKey, retriesLeft) {
  let regions;
  try {
	const response = await fetch(url);
	const data = await response.json();
	regions = data.regions;
  } catch(error) {
	if (retriesLeft > 0) {
	  await new Promise(r => setTimeout(r, 1000));	// NOTE: sleep 1 second
	  regions = await fetchCountryRegions(url, countryKey, retriesLeft - 1);
	} else {
	  throw error;
	}
  }
  return regions;
}

function handleCountrySelect(countryId, regionSelect, countryDatabaseUrl) {
  if (countryId === "" || countryId === null) {
	  return;
  }
  const countryKey = countryId.toString();
  if (countriesDataCache.hasOwnProperty(countryKey)) {
	  updateRegionSelect(countriesDataCache[countryKey].regions || countriesDataCache[countryKey] || [], regionSelect);
  } else {
	const url = new window.URL(countryDatabaseUrl, document.baseURI);
	url.pathname = `${url.pathname}${countryKey}/`;
	fetchCountryRegions(url.toString(), countryKey, 4).then(regions => {
	  countriesDataCache[countryKey] = regions;
	  updateRegionSelect(countriesDataCache[countryKey], regionSelect);
	}).catch(error => {
	  if (Sentry && Sentry.captureException) {
		  Sentry.captureException(error);
	  }
	});
  }
}

window.bindRegionField = function(countrySelect, regionSelect, countryDatabaseUrl) {
	if (countrySelect) {
		countrySelect.addEventListener("change", function(event) {
			handleCountrySelect(event.target.value, regionSelect, countryDatabaseUrl);
		});
		handleCountrySelect(countrySelect.value, regionSelect, countryDatabaseUrl);
	} 
}
